/**
 * Gated rollout for the redesigned Revenue (Ingresos) experience.
 *
 * The set of accounts that see the new navigation and views is provided
 * through the `VUE_APP_REVENUE_ALLOWED_ACCOUNTS` environment variable, as a
 * comma-separated list of account IDs. A single `*` entry allows every
 * account, which is what the development `.env` uses; dropping the `*`
 * locally is how you get the legacy experience back to compare against.
 *
 * When the variable is empty or unset, every account gets the legacy
 * experience.
 *
 * This is a rollout switch, not a security boundary: the gated routes stay
 * reachable by URL and nothing here is enforced by the API.
 */
const allowedAccounts = (process.env.VUE_APP_REVENUE_ALLOWED_ACCOUNTS || '')
  .split(',')
  .map(id => id.trim())
  .filter(Boolean)

/**
 * Return whether the given account sees the redesigned Revenue experience.
 * @param {string} accountId current account id (e.g. state.auth.account.id)
 * @returns {boolean} true for the new experience, false for the legacy one
 */
export function hasRevenueAccess (accountId) {
  if (!accountId) {
    return false
  }
  if (allowedAccounts.includes('*')) {
    return true
  }
  return allowedAccounts.includes(accountId)
}

export { allowedAccounts }
